// The Source filter describes who performed the activity. metadata.source
// may instead describe where discovered records came from (a website).
export function activitySource(activity = {}) {
  const metadata = activity.metadata || {};
  const normalize = (value) => String(value || "").trim().toLowerCase();
  const aliases = { human: "Human", manual: "Human", user: "Human", agent: "Agent", ai: "Agent", "ai agent": "Agent", system: "System", automated: "System" };
  for (const value of [metadata.actor_type, metadata.source]) {
    const category = aliases[normalize(value)];
    if (category) return category;
  }
  const actor = normalize(activity.actor_name || activity.actorName);
  if (/^(ai(?: agent)?|agent|system|ai \/ system)$/.test(actor)) {
    return actor === "system" || actor === "ai / system" ? "System" : "Agent";
  }
  if (metadata.ai_generated === true || metadata.ai_generated === 1 || metadata.ai_generated === "true" ||
      /(?:enrichment|discovery|career.*scan)/i.test(metadata.workflow_kind || "") ||
      ["company_job", "company_contact", "company_lead"].includes(metadata.review_kind)) return "Agent";
  const userId = activity.actor_user_id ?? activity.actorUserId;
  if ((userId != null && Number(userId) > 0) || (actor && actor !== "unassigned")) return "Human";
  return "System";
}
